import api from "app/lib/api";
import endpoints from "static/endpoints";
import { interpolate } from "utils/string";

export const getPatientMedications = async (patientId) => {
  let url = interpolate(endpoints.patient.fetchMedications, { patientId });
  const response = await api.get(url);
  return response;
};

export const addPatientMedication = async (payload) => {
  let url = endpoints.patient.addOrUpdateMedication;
  const response = await api.post(url, payload);
  return response;
};

export const updatePatientMedication = async (payload) => {
  let url = endpoints.patient.addOrUpdateMedication;
  const response = await api.put(url, payload);
  return response;
};

export const deletePatientMedication = async (payload) => {
  const { patientId, medicationId } = payload;
  let url = interpolate(endpoints.patient.deleteMedication, {
    patientId,
    medicationId,
  });
  const response = await api.delete(url);
  return response;
};
